import { ApiResponse, http } from '@config/api';

type Slug = 'request-and-offer' | 'ongoing-project';

export async function getOffers(slug: Slug): Promise<any> {
	const response = await http.get<ApiResponse<any>>(`monitoring`, `ongoing-request/${slug}`);

	return response.data ?? [];
}

export async function getOffersSpecialist(slug: Slug): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', `specialist-monitoring-request`);

	return response.data ?? [];
}

export async function getFarmerDataById(id: string): Promise<any> {
	const response = await http.get<ApiResponse<any>>('users', `get-farmer-information/${id}`);

	return response.data ?? [];
}

export async function getCropsByIds(ids: any): Promise<any> {
	const response = await http.get<ApiResponse<any>>('crops', 'list/get-by-id/', {
		ids: ids.join(','),
	});

	return response.data.data;
}

export async function getSpecialistsByIds(ids: any): Promise<any> {
	const idList = Array.isArray(ids) ? ids : [ids];

	const response = await http.get<ApiResponse<any>>('users', 'get-specialist-by-id/', {
		ids: idList.join(','),
	});

	return response.data.data;
}

export async function getCountriesByIds(ids: any): Promise<any> {
	const idList = Array.isArray(ids) ? ids : [ids];

	const response = await http.get<ApiResponse<any>>('countries', 'list/get-by-id', {
		ids: idList.join(','),
	});

	return response.data.data;
}

export async function selectSpecialist(request_id: any, specialist_id: any): Promise<any> {
	const response = await http.put<ApiResponse<any>>(
		'monitoring',
		`select_specialist/${request_id}`,
		{
			specialist_id,
		}
	);

	return response.data ?? [];
}

export async function getCategories(id: any, request_id: any): Promise<any> {
	const response = await http.get<ApiResponse<any>>(
		'monitoring',
		`phases/get-check-up-categories/${id}?request_id=${request_id}`
	);

	return response.data.data;
}

export async function getGuideline(id: string): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', 'guidelines/get-item', {
		topic_id: id,
	});

	return response.data.data;
}

export async function createTopicFiles(data: any): Promise<any> {
	const response = await http.post<ApiResponse<any>>('monitoring', 'create-topic-files', data);

	return response.data.data;
}

export async function getCompletedOffers(): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', 'completed-monitoring-request');

	return response.data ?? [];
}

export async function getTopicAttachments(topicId: string, categoryId: string, requestId?: string): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', 'get-topic-attachment', {
		topic_id: topicId,
		category_id: categoryId,
		request_id: requestId,
	});

	return response.data.data;
}

export async function deleteTopicAttachment(
	topicId: string,
	categoryId: string,
	attachmentId: string,
	requestId?: string
): Promise<any> {
	const response = await http.delete<ApiResponse<any>>('monitoring', 'delete-topic-attachment', {
		topic_id: topicId,
		category_id: categoryId,
		attachment_id: attachmentId,
		request_id: requestId,
	});

	return response.data.data;
}
